export default __webpack_public_path__ + "static/media/02AW2SEP66.288d19cf.jpg";